import React, { forwardRef, ComponentPropsWithoutRef, useMemo } from "react";

import { StyledCaretIcon, StyledSelectTrigger } from "./Styles";
import { InputMode, InputSize } from "../Input/types";
import { ITypographyProps, Typography } from "../Typography/Typography";

export interface SelectTriggerProps extends ComponentPropsWithoutRef<"button"> {
  size?: InputSize;
  invalid?: boolean;
  endAdornment?: JSX.Element;
  open?: boolean;
  typographyProps?: ITypographyProps;
  mode?: InputMode;
}

export const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
  (
    {
      children,
      type = "button",
      size = "regular",
      invalid = false,
      open = false,
      endAdornment,
      typographyProps,
      mode = "outlined",
      ...rest
    },
    ref
  ) => {
    const variant = useMemo(() => {
      if (size === "big") {
        return "Body 1";
      }
      if (size === "biggest") {
        return "Header 2";
      }
      return "Body 2";
    }, [size]);
    return (
      <StyledSelectTrigger
        ref={ref}
        role="button"
        type={type}
        $size={size}
        $invalid={invalid}
        aria-invalid={invalid}
        $mode={mode}
        {...rest}
      >
        <Typography
          as="div"
          overflow="truncate"
          whitespace="no-wrap"
          variant={variant}
          weight={size === "biggest" ? "bold" : "regular"}
          color={mode === "flat" && invalid ? "alert" : undefined}
          {...typographyProps}
        >
          {children}
        </Typography>

        {endAdornment ? endAdornment : <StyledCaretIcon $open={open} />}
      </StyledSelectTrigger>
    );
  }
);

SelectTrigger.displayName = "SelectTrigger";
